import { STRAVA_HEATMAP_SPORTS } from "@/constants/strava.const";
import type { SportType } from "@/types/data.types";
import type { SportsFilter } from "@/types/filters.types";

export function isSportChecked(filter: SportsFilter, s: SportType): boolean {
  switch (filter.mode) {
    case "all":
      return true;
    case "include":
      return filter.sports.includes(s);
    case "exclude":
      return !filter.sports.includes(s);
  }
}

export function toggleSport(filter: SportsFilter, s: SportType): SportsFilter {
  switch (filter.mode) {
    case "all":
      return { mode: "exclude", sports: [s] };

    case "include": {
      const has = filter.sports.includes(s);
      const sports = has
        ? filter.sports.filter((x) => x !== s)
        : [...filter.sports, s];
      return { mode: "include", sports };
    }

    case "exclude": {
      const has = filter.sports.includes(s);
      const sports = has
        ? filter.sports.filter((x) => x !== s)
        : [...filter.sports, s];
      // If exclude becomes empty, collapse back to "all"
      if (sports.length === 0) return { mode: "all" };

      return { mode: "exclude", sports };
    }
  }
}

export function clearSports(): SportsFilter {
  return { mode: "include", sports: [] };
}

export function filterToStravaHeatmapSport(
  filter: SportsFilter,
): string | null {
  if (filter.mode == "all") return "all";

  if (filter.mode !== "include") return null;
  if (filter.sports.length !== 1) return null;

  const sport = filter.sports[0];
  if (!STRAVA_HEATMAP_SPORTS.has(sport)) return null;

  return `sport_${sport}`;
}
